import React from 'react'

import {
  Dialog,
  DialogContent,
  DialogCloseButton,
  DialogHeader,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type TDialogPengembanganKompetensiInfoProps = {
  isOpen: boolean
  onClose: () => void
}
export const DialogPengembanganKompetensiInfo: React.FC<
  TDialogPengembanganKompetensiInfoProps
> = ({ isOpen, onClose }) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      autoFocus={false}
      returnFocus={false}
      size="md"
    >
      <DialogOverlay />
      <DialogContent>
        <DialogHeader title="Tentang Pengembangan Kompetensi" />

        <div className="p-6 space-y-8">
          <div className="space-y-1">
            <Text variant="heading-md">Sebuah Investasi Jangka Panjang</Text>
            <Text>
              Bayangkan Pengembangan Kompetensi bukan sebagai tugas yang harus
              diselesaikan saja. Namun, sebagai investasi jangka panjang untuk
              pengembangan profesional Anda sebagai Penilik.
            </Text>
          </div>

          <div className="space-y-4">
            <Text variant="heading-md">Tahapan Pengembangan Kompetensi</Text>

            <div className="space-y-2">
              <Text variant="heading-sm">Tahap Perencanaan</Text>
              <Text>
                <ol className="pl-6 list-decimal">
                  <li>
                    Memilih 1 Indikator untuk menjadi fokus peningkatan kinerja.
                  </li>
                  <li>
                    Memilih kebutuhan dan cara meningkatkan Indikator tersebut.
                  </li>
                </ol>
              </Text>
            </div>

            <div className="space-y-2">
              <Text variant="heading-sm">Tahap Pelaksanaan</Text>
              <Text>
                Pengisian refleksi terhadap kegiatan untuk meningkatkan
                Indikator yang dipilih.
              </Text>
            </div>

            <div className="space-y-2">
              <Text variant="heading-sm">Tahap Penilaian</Text>
              <Text>
                Pengembangan Kompetensi tidak menjadi nilai utama dari
                keseluruhan Pengelolaan Kinerja Anda dan hanya menjadi
                pertimbangan bagi Tim Kinerja dan Pejabat Penilai Kinerja.
              </Text>
            </div>
          </div>
        </div>

        <DialogCloseButton />
      </DialogContent>
    </Dialog>
  )
}
